import { render } from "./AreaOpen.vue?vue&type=template&id=021b2401"
import script from "./AreaOpen.vue?vue&type=script&lang=js"
export * from "./AreaOpen.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__